"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setSupplierId = void 0;
var facct_1 = require("./facct");
var setSupplierId = function (supplierId) {
    (0, facct_1.callWindowGib)(function () {
        var _a;
        if (supplierId) {
            (_a = window.gib) === null || _a === void 0 ? void 0 : _a.setAttribute('supplier_id', supplierId, { persistent: true, encryption: null });
        }
    });
};
exports.setSupplierId = setSupplierId;
//# sourceMappingURL=set-supplier-id.js.map